import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "@/context/LangContext";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/screens/Landing";
import Intro from "@/screens/Intro";
import Game from "@/screens/Game";
import EndScreen from "@/screens/EndScreen";
import Leaderboard from "@/screens/Leaderboard";
import AuthCallback from "@/screens/AuthCallback";

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/intro" element={<Intro />} />
      <Route path="/play" element={<Game />} />
      <Route path="/result" element={<EndScreen />} />
      <Route path="/leaderboard" element={<Leaderboard />} />
    </Routes>
  );
};

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <div className="app-bg">
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
        </div>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
